export const CardLayout = ({
  children,
  title,
  subtitle,
  fullHeight = false,
  headerExtra,
}: {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  fullHeight?: boolean;
  headerExtra?: React.ReactNode;
}) => {
  return (
    <CardContainer
      className={`${fullHeight ? "h-full" : ""} flex flex-col`}
      data-testid="summary-card"
      data-card-title={title}
    >
      <div className="p-3 border-b border-[#E5E5E5] relative">
        <h3 className="text-[16px] font-semibold ">{title}</h3>
        <p className="text-[12px] text-[#8C8C8C]">{subtitle}</p>
        {headerExtra && (
          <div className="absolute top-2 right-2">{headerExtra}</div>
        )}
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </CardContainer>
  );
};

export const CardContainer = ({
  children,
  className = "",
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={`bg-white rounded-lg w-full ${className}`} {...props}>
      {children}
    </div>
  );
};
